<template>
    <div>
        <ac-modal :title="'Signup Wizard'" ref="modal" :sizeClass="'modal-lg'">
            <template>
                <div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="progress">
                                <div class="progress-bar progress-bar-striped" role="progressbar" ref="progressBar"
                                     style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" :class="isFormComplete ? 'form-complete':''">
                        <div class="col-md-3 step">
                            <div class="step-square center-block" :class="currentStep==1 ? 'active-step':''">
                                <h4>
                                    <span @click.prevent="goToStep(1)">Account Setup</span>
                                </h4>
                            </div>
                        </div>
                        <div class="col-md-3 step">
                            <div class="step-square center-block" :class="currentStep==2 ? 'active-step':''">
                                <h4>
                                    <span @click.prevent="goToStep(2)">Additional Members</span>
                                </h4>
                            </div>
                        </div>
                        <div class="col-md-3 step">
                            <div class="step-square center-block" :class="currentStep==3 ? 'active-step':''">
                                <h4>
                                    <span @click.prevent="goToStep(3)">Terms of Use</span>
                                </h4>
                            </div>
                        </div>
                        <div class="col-md-3 step">
                            <div class="step-square center-block" :class="currentStep==4 ? 'active-step':''">
                                <h4>
                                    <span @click.prevent="goToStep(4)">Confirmation</span>
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div class="row" style='padding:5px;'>
                        <div class="col-md-12">
                            <div v-show="currentStep===1 && !isFormComplete">
                                <div class="row" v-if="widgetReady">
                                    <div class="col-lg-12">
                                        <div class="alert alert-info">
                                            Your benefits will start on <strong>{{ vm.mainModel.effStartDate | shortDate }}</strong>
                                        </div>
                                    </div>
                                </div>
                                <form v-if="widgetReady" onsubmit="return false;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4>General Information</h4>
                                        </div>
                                    </div>
                                    <generic-profile-info v-model="vm.contactInfo">

                                    </generic-profile-info>
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <div class="form-group">
                                                <label>Social Security Number</label>
                                                <small v-if="ssnRequired">&nbsp;<span class="redText">required</span></small>
                                                <ac-social-security-number v-model="vm.mainModel.ssn">

                                                </ac-social-security-number>
                                            </div>
                                        </div>
                                        <div class="col-lg-3">
                                            <div class="form-group">
                                                <label>DOB
                                                    <small><span class="redText"> required </span></small>
                                                </label><br/>
                                                <ac-date-picker v-model="vm.mainModel.birthDate"></ac-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="dateOption" class="row">
                                        <div class="col-md-12">
                                            <h4>Effective Start Date</h4>
                                            <div class="form-check">
                                                <input v-model="vm.mainModel.effStartDate" class="form-check-input btn-default" type="radio" name="exampleRadios" id="effStartDate"
                                                       v-bind:value="today">
                                                <label class="form-check-label label-font" for="effStartDate">
                                                    Today ({{ today | shortDate }})
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input v-model="vm.mainModel.effStartDate" class="form-check-input" type="radio" name="exampleRadios" id="firstOfNextMonth"
                                                       v-bind:value="firstOfNextMonth">
                                                <label class="form-check-label label-font" for="firstOfNextMonth">
                                                    Start of Next Month ({{ firstOfNextMonth | shortDate }})
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4>Home Address</h4>
                                            <ac-address v-model="vm.mainModel.address"></ac-address>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4>Login Credentials</h4>
                                            <generic-user-info v-model="vm.userViewModel"></generic-user-info>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="button-box">
                                                <ac-button type="button" class="btn-green btn-sm" :action="validateAccountSetUp">
                                                    CONTINUE
                                                </ac-button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div v-show="currentStep===2 && !isFormComplete">
                                <div class="row" style="padding: 5px 5px 5px 25px;">
                                    <div class="col-md-12">
                                        <div class="alert alert-info">
                                            If you don’t want to add family members, please proceed to terms of use
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <add-dependent ref="addDependents" :ssn-required="ssnRequired" :company-id="companyId"></add-dependent>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="button-box">
                                            <ac-button class="btn-green btn-sm" :action="proceedToTermsAndConditions">
                                                CONTINUE
                                            </ac-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="currentStep===3 && !isFormComplete">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group" style="padding: 5px;">
                                            <input type="checkbox" v-model="acceptTerms" id="terms">
                                            <label for="terms">
                                                I agree to the <a :href="pdfUrl" target="_blank" style="text-decoration: underline!important;">Terms & Conditions</a>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row padding-bottom-20">
                                    <recaptcha ref="captcha"></recaptcha>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="button-box">
                                            <button class="btn btn-green btn-sm" @click.prevent="completeSetUp" :disabled="!acceptTerms">
                                                CONTINUE
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="currentStep===4" class="step-4">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p>Account set up complete! Your next step is to select a healthcare provider.</p>
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item">User Name</li>
                                            <li class="list-group-item">{{ vm.userViewModel.userName }}</li>
                                        </ul>
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item">Members</li>
                                            <li class="list-group-item">
                                                {{ vm.contactInfo.firstName }} {{ vm.contactInfo.lastName }}
                                            </li>
                                            <li class="list-group-item" v-if="spouse">
                                                {{ spouse.contactInfo.firstName }} {{ spouse.contactInfo.lastName }}
                                            </li>
                                            <li class="list-group-item" v-for="item in children" :key="item.contactInfo.contactId">
                                                {{ item.contactInfo.firstName }} {{ item.contactInfo.lastName }}
                                            </li>
                                        </ul>
                                        <p v-if="currentContributions != 0 && hidePhysicianPricing === false">
                                            Your total available monthly credit is {{ currentContributions | currency }}
                                        </p>
                                        <p>Now let's select a healthcare provider.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="button-box">
                                            <ac-button class="btn-green btn-sm" :action="logInAndRedirect">
                                                CONTINUE TO SELECT A PROVIDER
                                            </ac-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </ac-modal>
    </div>

</template>

<script>
import {configTables} from "../../../../global/configTables.js";
import {common} from "../../../../global/common.js";
import {formatter} from "../../../../global/formatter.js";
import GenericProfileInfo from "../../../../components/shared/GenericProfileInfo.vue";
import GenericUserInfo from "../../../../components/shared/GenericUserInfo.vue";
import {api} from "../../../../global/framework/api.js";
import {notifications} from "../../../../global/notifications.js";
import {bootstrapModalHelper} from "../../../../global/bootstrapModalHelper.js";
import AcAddress from "../../../../components/custom/AcAddress.vue";
import AddDependent from "../../../../components/shared/consumer/AddDependent.vue";
import Recaptcha from "../../../../components/shared/Recaptcha.vue";


export default {
    name: "SignUpModal",
    components: {Recaptcha, AcAddress, AddDependent, GenericUserInfo, GenericProfileInfo},
    props: {companyId: {type: Number, required: true}, token: {type: String, required: true}, dateOption: {type: Boolean, required: true}},
    data() {
        return {
            currentStep: 1,
            stepsCompleted: [0],
            backgroundColor: '',
            color: '',
            widgetReady: false,
            vm: {},
            coverageTypes: [],
            spouse: {},
            children: [],
            childTemplate: {},
            acceptTerms: false,
            consumerId: 0,
            currentContributions: 0,
            hidePhysicianPricing: false,
            isFormComplete: false,
            loginData: {},
            firstOfNextMonth: '',
            today: null,
            pdfUrl: `https://www.myameriflex.net/Document/Viewer/c0a7bf1aa9894d7e98dd4b80b6393f67`,
            ssnRequired: false
        };

    },
    methods: {
        isStepCompleted(step) {
            return this.stepsCompleted.includes(step);
        },
        async showModal() {
            if (!this.widgetReady) {
                await this.setWhitelabelStyle();
                await this.setVm();
                this.widgetReady = true;
            }
            this.$refs.modal.open();
        },
        async setWhitelabelStyle() {
            this.backgroundColor = $('.navbar-default').css("background-color");
            await this.$nextTick();
            //console.log("this.background: ", this.backgroundColor, "elements:", $('.step-square'));
            $(".step-square").css('border-color', this.backgroundColor);
            $(this.$refs.progressBar).css('background-color', this.backgroundColor);
        },
        async setVm() {
            configTables.getCoverageOptions().then((options) => {
                this.coverageTypes = options
            });
            let url = `ProviderSearch/${this.companyId}/GetSignUpTemplate`;
            url = common.appendUrlParameter(url, 'token', this.token);
            let data = await $.ajax({type: "Get", url: url});
            this.firstOfNextMonth = data.firstOfNextMonth;
            this.mapData('vm', data.consumerWizardVM);
            this.today = this.vm.mainModel.effStartDate;
            this.ssnRequired = !!data.ssnRequired;
        },
        cancel() {
            this.$refs.modal.close();
        },
        goToStep(stepNumber) {
            let prevStep = stepNumber - 1;
            if (this.isFormComplete) {
                //if the user is created only show the confirmation page
                this.currentStep = 4;
                return;
            }
            if (this.stepsCompleted.includes(prevStep)) {
                this.currentStep = stepNumber;
            } else {
                notifications.showError({
                    title: 'Unable to proceed',
                    message: 'You need to complete the previous step in order to continue'
                });
            }
        },
        async validateAccountSetUp() {
            if (this.ssnRequired) {
                const digits = this.vm.mainModel && this.vm.mainModel.ssn
                    ? String(this.vm.mainModel.ssn).replace(/\D/g, '')
                    : '';
                if (digits.length !== 9) {
                    notifications.showError({ message: "Social Security Number is required", title: "Error" });
                    return;
                }
            }
            //Validate account info
            let result = await api.post('ProviderSearch', 'ValidateAccountCreation',
                {ConsumerWizardVm: this.vm, spouse: this.spouse, children: this.children}, true);
            if (result) {
                $(this.$refs.progressBar).css('width', 33 + '%').attr('aria-valuenow', 33);
                this.stepsCompleted.push(1);
                this.currentStep = 2;
            }
        },
        proceedToTermsAndConditions() {
            $(this.$refs.progressBar).css('width', 66 + '%').attr('aria-valuenow', 66);
            this.stepsCompleted.push(2);
            this.currentStep = 3;
        },
        addDependentAddresses(allDependents) {
            let self = this;
            allDependents.forEach(function (dependent, index) {
                dependent.address = {...self.vm.mainModel.address};
            });
        },
        async completeSetUp() {
            //If a user already accepted TOS dont try to create user again
            if (this.consumerId != 0) {
                this.gotoReviewPage(this.consumerId);
            } else {
                let captchaCheck = await this.$refs.captcha.checkCaptcha();
                if (captchaCheck == true) {
                    let allDependents = this.$refs.addDependents.getAllDependents();
                    this.addDependentAddresses(allDependents);
                    let spouse = allDependents.filter(dependent => dependent.isSpouse == true);
                    let children = allDependents.filter(dependent => dependent.isSpouse != true);
                    this.spouse = spouse[0];
                    this.children = children;
                    let data = {
                        consumerWizardVm: this.vm, spouse: this.spouse ? this.spouse : null,
                        children: this.children, companyId: this.companyId, token: this.token
                    };
                    let result = await api.postDataAsJson('ProviderSearch', 'CompleteSignUpProcess', data);
                    if (result) {
                        this.consumerId = result.data.consumerId;
                        this.loginData = result.data;
                        this.gotoReviewPage(this.consumerId);
                    }
                }
            }
        },
        async gotoReviewPage(consumerId) {
            this.isFormComplete = true;
            let url = `ProviderSearch/${this.companyId}/GetEmployerContributions/${consumerId}`;
            url = common.appendUrlParameter(url, 'token', this.token);
            let data = await $.ajax({type: "Get", url: url});
            this.currentContributions = data.currentContributions;
            this.hidePhysicianPricing = data.hidePhysicianPricing;
            $(this.$refs.progressBar).css('width', 100 + '%').attr('aria-valuenow', 100);
            this.stepsCompleted.push(3);
            this.currentStep = 4;
        },
        logInAndRedirect() {
            let redirectUrl = `/consumer/#/${this.consumerId}/checkPhysicians`;
            common.logUserInWithToken(this.loginData.token, this.loginData.userId, true, redirectUrl);
        },
    },
    mounted() {
        bootstrapModalHelper.init();
    }
}
</script>

<style scoped>
.step {
    text-align: center;
    vertical-align: middle;
    padding: 5px;
}

.step-square {
    padding: 5px;
    width: 80%;
    text-align: center;
    border-bottom: 2px solid gray;
    opacity: 0.6;
}

.step-square span {
    vertical-align: middle;
}

.step-square h4 {
    cursor: pointer;
}

.step-4 p {
    font-size: 16px;
}

.form-complete .step-square h4 {
    cursor: default;
}

.dependent-button {
    width: 140px;
}

.alert-relative {
    position: relative;
}

.button-container {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
}

.check-completed {
    color: green;
}

.active-step {
    opacity: 1;
}

.modal {
    overflow: auto !important;
}

.padding-bottom-20 {
    padding-bottom: 20px;
}

label.form-check-label.label-font {
    font-size: 12.5px;
}
</style>